import React, { useState, useEffect } from 'react'
import Loader from '../../presentationals/Loader/Loader.component'
import Popup from './Popup.component'
import { applyManualNachAPIPayment, applyManualNachAPIPaymentMaincode, getAggregatorSummayryId } from '../../containers/Admin/AdminActionCreator.component'
import { ABHICASH_ONLY, CASHBRIDGE_LIKE, CHECK_COMPANY_TENANT, CREDFIN_LIKE } from '../../../layouts/MainTenantconfig'
import { buildTenantHeader } from '../../../utils/apiHeaders'
export default function ManualNachPopup({ data, handleManualNAch,customTenantDefaults }) {
    const customHeaderTenant = CHECK_COMPANY_TENANT(CREDFIN_LIKE) || CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) || CHECK_COMPANY_TENANT(ABHICASH_ONLY) ? buildTenantHeader(customTenantDefaults?.sourceAggregatorTenant ?? null) : null
    const [paymentType, setpaymentType] = useState("")
    const [amount, setamount] = useState("")
    const [loader, setloader] = useState(false)
    const [balanceData,setBalanceData] =useState(0)
    const [popup, setpopup] = useState({ popupStatus: "", show: false })

    const handleApply = () => {
        setloader(true)
        const datanew = {
            "gateway": (data?.gateway)?.toUpperCase(),
            "triggeredBy": data?.triggeredBy,
            "paymentType": paymentType,
            "overrideAmount": amount,
            "targets": [
                {
                    "loanId": data?.loanId,
                    "emiId": data?.emiId
                }
            ]
        }
        console.log("data", datanew)
        if (CHECK_COMPANY_TENANT(CREDFIN_LIKE)) {
            applyManualNachAPIPaymentMaincode(datanew, callback => {
                handleManualNAch(false, {})
                setloader(false)
                setpopup({ show: true, popupStatus: "success" })
                setpopup({ show: true, popupStatus: "Failure" })
                setTimeout(() => {
                    closePopup()
                }, 5000)
            })

        } else {
            applyManualNachAPIPayment(datanew, callback => {
                handleManualNAch(false, {})
                setloader(false)
                setpopup({ show: true, popupStatus: "success" })
                setpopup({ show: true, popupStatus: "Failure" })
                setTimeout(() => {
                    closePopup()
                }, 5000)
            })

        }
    }

    useEffect(()=>{
        api()
    },[])

    const api = () => {
        setloader(true)
        getAggregatorSummayryId(data?.userId,customHeaderTenant, callback => {
            setloader(false)
            setBalanceData(callback?.data?.Summary?.currentBalance ?? 0)
        })
    }

    const closePopup = () => {
        setpopup({ show: false, popupStatus: "" })
    }


    return (
        <>
            {loader ? <Loader /> : ""}
            {popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ""}
            <div className="background-blur income">
                <div className='popup-main small-popup container-fluid dbl-border' style={{ width: '70%', marginTop: '10%' }}>
                    <div className='' style={{ float: 'right' }}>
                        <span className="font-weight-bold" style={{ cursor: 'pointer' }} onClick={() => handleManualNAch(false, {})}>X</span>
                    </div>
                    <div className="header-text">
                        <h6 className="modal-title">
                            <strong>Manual NACH</strong>
                        </h6>

                    </div>
                    <div style={{marginTop:'20px',display:'flex',justifyContent:'space-between'}}>

                        <div>
                            Current Balance: <span style={{color:balanceData > 0 ? "green":"red"}}>{balanceData}</span>
                        </div>
                        <button className="btn btn-primary" style={{margin:'0'}} onClick={()=>api()}>Refetch</button>
                    </div>


                    <div className="modal-body">
                        {/* <div> <h5 style={{ color: '#000', background: 'yellow', width: '140px' }}>Emi Amount: {PopupOverDueAmount.AMOUNT}</h5></div> */}

                        <div className='row'>
                            <div className='col-sm-6 col-xs-12'>
                                <h6 className=""> Type of Payment </h6>
                                <div className="" style={{ marginBottom: '15px', }}>
                                    <select
                                        style={{ width: '100%' }}
                                        value={paymentType}
                                        className="form-control "
                                        onChange={(e) => setpaymentType(e.target.value)}
                                    >
                                        <option value=''>Select Type</option>
                                        <option value="PART">Part Payment</option>
                                        <option value="FULL">Full Payment</option>
                                    </select>
                                </div>
                            </div>
                            <div className='col-sm-6 col-xs-12'>
                                <h6 className="">Amount </h6>
                                <div className="" style={{ marginBottom: '15px' }}>
                                    <input value={amount} type="number" className="form-control w-50" onChange={(e) => setamount(e.target.value)} placeholder="Enter Amount" />
                                </div>
                            </div>


                        </div>



                    </div>



                    <div className='text-center'>
                        <button className='btn btn-primary' onClick={() => handleApply()}>Procced</button>
                    </div>

                </div>

            </div>
        </>
    )
}
